'use client';
import NextImage, { StaticImageData } from 'next/image';
import { useIntersectionObserver } from '@hooks/useIntersectionObserver';
import { ReactNode } from 'react';

interface IProps {
  imgSrc: StaticImageData;
  imgAlt: string;
  imgRight?: boolean;
  headingText?: string;
  bodyText?: string;
  readMoreLink?: string;
  children?: ReactNode;
  className?: string;
}

export const CircleImage = ({ imgSrc, imgAlt, imgRight = false }: IProps) => {
  const [isInView, ref] = useIntersectionObserver({});
  const translateX = imgRight ? 'translateX(100%)' : 'translateX(-100%)';

  return (
    <div ref={ref} className={`sm:w-col-5 md:w-col-4 flex w-full justify-start overflow-hidden`}>
      <NextImage
        style={{
          opacity: isInView ? 1 : 0,
          transform: isInView ? 'translateX(0)' : translateX,
          transition: 'opacity 1s ease-in-out 0.25s, transform 1s ease-in-out 0.25s',
        }}
        alt={imgAlt}
        className="size-full object-cover sm:mb-0"
        src={imgSrc}
        placeholder="blur"
      />
    </div>
  );
};
